import { StorageFileQuality } from '@/core/campaign/enums/Campaign';
import { StoredFile } from '@/core/campaign/models/CampaignMedia';

export const filterAndSortThumbnails = (thumbnails: StoredFile[] | undefined) => {
  return thumbnails
    ?.filter((thumb) => thumb.quality === StorageFileQuality.ORIGINAL || thumb.quality === StorageFileQuality.MEDIUM)
    ?.sort((a, b) => a.storagePath.localeCompare(b.storagePath));
};
